"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.v10Upgrade = exports.v10Downgrade = void 0;
const v10Downgrade = (rule) => {
    const { ubCode, embUuid, trigger, published, frequency, referrerTargets, id, integrations, event, version, parentVersion, meta, urlTargets, cookieTargets, geoTargets, displaySettings, } = rule;
    const { mobileEnabled, desktop, mobile } = rule.dimensions;
    let dimensions;
    // if-cases here are to satisfy Flow, which wants explicitness when defining union type members
    if (mobileEnabled === true) {
        dimensions = {
            mobileEnabled: true,
            desktop,
            mobile,
        };
    }
    else if (mobileEnabled === false) {
        dimensions = {
            mobileEnabled: false,
            desktop,
            mobile,
        };
    }
    else {
        dimensions = {
            mobileEnabled: null,
            desktop,
            mobile,
        };
    }
    return {
        ubCode,
        embUuid,
        trigger,
        displaySettings,
        published,
        frequency,
        referrerTargets,
        id,
        integrations,
        event,
        version,
        parentVersion,
        meta,
        cookieTargets,
        geoTargets,
        urlTargets,
        schemaVersion: 9,
        dimensions,
    };
};
exports.v10Downgrade = v10Downgrade;
const v10Upgrade = (rule) => {
    const { ubCode, embUuid, trigger, published, frequency, referrerTargets, displaySettings, id, integrations, event, version, parentVersion, meta, urlTargets, cookieTargets, geoTargets, } = rule;
    const { mobileEnabled, desktop, mobile } = rule.dimensions;
    let dimensions;
    // if-cases here are to satisfy Flow, which wants explicitness when defining union type members
    if (mobileEnabled === true) {
        dimensions = {
            desktopEnabled: true,
            mobileEnabled: true,
            desktop,
            mobile,
        };
    }
    else if (mobileEnabled === false) {
        dimensions = {
            desktopEnabled: true,
            mobileEnabled: false,
            desktop,
            mobile,
        };
    }
    else {
        dimensions = {
            desktopEnabled: null,
            mobileEnabled: null,
            desktop,
            mobile,
        };
    }
    return {
        ubCode,
        embUuid,
        trigger,
        displaySettings,
        published,
        frequency,
        referrerTargets,
        id,
        event,
        version,
        parentVersion,
        dimensions,
        meta,
        cookieTargets,
        geoTargets,
        urlTargets,
        integrations,
        schemaVersion: 10,
    };
};
exports.v10Upgrade = v10Upgrade;
//# sourceMappingURL=v10.js.map